// Нижняя панель «Написать в MAX» на /coach. Перенос инлайн-скрипта макета
// (CSP инлайн режет): панель выезжает, когда кнопка героя ушла с экрана. На
// десктопе панель скрыта в CSS, скрипт об этом не знает. Кнопку героя ищем по
// data-атрибуту, а не по тексту, как в макете: текст правит владелец.
export function initCtaBar(root: Document): void {
  const bar = root.querySelector<HTMLElement>('[data-consult-dock]')
  if (!bar) return

  // Баннер cookie (fixed, bottom:16px, z выше панели) закрывает её, пока не принят:
  // на это время панель уезжает вниз, а после «Хорошо» возвращается.
  const banner = root.getElementById('cookie-consent')
  if (banner) {
    const sync = () => bar.classList.toggle('is-covered', !banner.hidden)
    sync()
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(sync).observe(banner, { attributes: true, attributeFilter: ['hidden'] })
    }
  }

  const anchor = root.querySelector<HTMLElement>('[data-consult-dock-anchor]')
  // Без кнопки героя или без IntersectionObserver панель просто видна: лучше
  // лишняя кнопка, чем потерянная.
  if (!anchor || typeof IntersectionObserver === 'undefined') {
    bar.classList.add('is-on')
    return
  }

  new IntersectionObserver((entries) => {
    bar.classList.toggle('is-on', !entries[0].isIntersecting)
  }, { threshold: 0 }).observe(anchor)
}
